/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Tiktok/theme';

export const TiktokTheme = theme;
